import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const siteContextMonitoringSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string().optional(),
  /** Monitoring surfaces folded in from legacy Dossiers views. */
  mode: z
    .enum(['sentinels', 'create-sentinel-from-docs'])
    .optional()
    .catch(undefined),
  /** Selected sentinel entry id. */
  sentinelId: z.string().optional(),
  /** In-progress sentinel design context (adv-viewer create flow). */
  designContextId: z.string().optional(),
})

export type SiteContextMonitoringSearchParams = z.infer<
  typeof siteContextMonitoringSearchParams
>
